import React, { useMemo, useCallback } from 'react';
import { Typography, Box } from '@mui/material';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import Paper from '@mui/material/Paper';
import TableBodyPermisos from 'src/components/table/TableBodyPermisos';
import useAuth from 'src/hooks/useAuth';
import { useTheme } from '@mui/material/styles';

import CircularProgress from '@mui/material/CircularProgress';

/* function createData(name, name_switch_ver, name_switch_editar) {
  return { name, name_switch_ver, name_switch_editar };
} */

const FormPermisos = ({ id, formik, loading }) => {
  const createData = useCallback(
    (name, name_switch_ver, name_switch_editar) => {
      return { name, name_switch_ver, name_switch_editar };
    },
    [],
  );
  const { user } = useAuth();

  const theme = useTheme();

  const rowsTelefonia = useMemo(
    () => [
      createData('Módulo Reporte', 'rep_modulo'),
      user.cliente?.modulos_permisos?.rep_calls_gral
        ? createData('Llamadas', 'rep_calls_v')
        : null,
      user.cliente?.modulos_permisos?.rep_calls_fail_gral
        ? createData('Llamadas Falladas', 'rep_calls_fail_v')
        : null,
      user.cliente?.modulos_permisos?.rep_calls_bloq_gral
        ? createData('Llamadas a bloqueados', 'rep_calls_bloq_v')
        : null,
      user.cliente?.modulos_permisos?.rep_por_fecha_gral
        ? createData('Resumen por Fecha', 'rep_por_fecha_v')
        : null,
      user.cliente?.modulos_permisos?.rep_prefijos_gral
        ? createData('Resumen Prefijos', 'rep_prefijos_v')
        : null,
      user.cliente?.modulos_permisos?.rep_ip_gral
        ? createData('Resumen IP', 'rep_ip_v')
        : null,
      user.cliente?.modulos_permisos?.rep_rep_bloq_gral
        ? createData('Informes de bloqueo', 'rep_rep_bloq_v')
        : null,
    ],
    [createData, user.cliente?.permisos_modulos_editar],
  );

  /* 'adm_modulo',
    'adm_ani_v',
    'adm_ani_e',
    'adm_bloq_v',
    'adm_bloq_e',
    'adm_num_bloq_v',
    'adm_num_bloq_e',
    'adm_hist_bloq_v', */
  const rowsAdministracion = useMemo(
    () => [
      user.cliente?.modulos_permisos?.adm_modulo_gral
        ? createData('Módulo Administración', 'adm_modulo')
        : null,
      user.cliente?.modulos_permisos?.adm_ani_gral
        ? createData(`ANI'S`, 'adm_ani_v', 'adm_ani_e')
        : null,
      user.cliente?.modulos_permisos?.adm_bloq_gral
        ? createData('CSV Bloqueos', 'adm_bloq_v', 'adm_bloq_e')
        : null,
      user.cliente?.modulos_permisos?.adm_num_bloq_gral
        ? createData('Números Bloqueados', 'adm_num_bloq_v', 'adm_num_bloq_e')
        : null,
      user.cliente?.modulos_permisos?.adm_hist_bloq_gral
        ? createData('Historial de Bloqueos', 'adm_hist_bloq_v')
        : null,
    ],
    [createData, user.cliente?.permisos_modulos_editar],
  );

  /* 'gra_modulo',
    'gra_min_util_v',
    'gra_min_util_e',
  
    'env_sms_simple_v',
    'env_sms_simple_e',
    'env_sms_masivo_v',
    'env_sms_masivo_e', */
  const rowsGraficos = useMemo(
    () => [
      user.cliente?.modulos_permisos?.gra_modulo_gral
        ? createData('Módulo Gráficos', 'gra_modulo')
        : '',
      user.cliente?.modulos_permisos?.gra_min_util_gral
        ? createData(`Minutos Utilizados`, 'gra_min_util_v')
        : '',
    ],
    [createData, user.cliente?.permisos_modulos_editar],
  );

  /* 'rep_sms_modulo',
    'rep_sms_status_env_v',
    'rep_sms_por_dia_v',
    'rep_sms_por_fecha_v',
    'rep_sms_env_v',
    'rep_sms_rec_v', */
  const rowModuloSmsEnvioIndividual = useMemo(
    () => [
      user.cliente?.modulos_permisos?.env_sms_simple_gral
        ? createData(
            'Envios Sms Individuales',
            'env_sms_simple_v',
            'env_sms_simple_e',
          )
        : null,
    ],
    [createData, user.cliente?.permisos_modulos_editar],
  );
  const rowModuloSmsEnvioMasivo = useMemo(
    () => [
      user.cliente?.modulos_permisos?.env_sms_masivo_gral
        ? createData(
            `Envios Sms Masivos`,
            'env_sms_masivo_v',
            'env_sms_masivo_e',
          )
        : null,
    ],
    [createData, user.cliente?.permisos_modulos_editar],
  );
  const rowModuloReportesSms = useMemo(
    () => [
      user.cliente?.modulos_permisos?.rep_sms_modulo_gral
        ? createData('Módulo Reportes Sms', 'rep_sms_modulo')
        : null,
      user.cliente?.modulos_permisos?.rep_sms_status_env_gral
        ? createData('Estados de Envios', 'rep_sms_status_env_v')
        : null,
      user.cliente?.modulos_permisos?.rep_sms_por_dia_gral
        ? createData(`Resumen Por Dia`, 'rep_sms_por_dia_v')
        : null,
      user.cliente?.modulos_permisos?.rep_sms_por_fecha_gral
        ? createData(`Informe de Enviados`, 'rep_sms_por_fecha_v')
        : null,
      user.cliente?.modulos_permisos?.rep_sms_env_gral
        ? createData(`SMS Enviados`, 'rep_sms_env_v')
        : null,
      user.cliente?.modulos_permisos?.rep_sms_rec_gral
        ? createData(`SMS Recibidos`, 'rep_sms_rec_v')
        : null,
    ],
    [createData, user.cliente?.permisos_modulos_editar],
  );

  /* 'env_sms_sim_ng_v',
  'env_sms_sim_ng_e',
  'env_sms_mas_ng_v',
  'env_sms_mas_ng_e',
  'api_doc_sms_ng_v',
  'api_doc_sms_ng_e',
  'status_sms_ng_v',
  'status_sms_ng_e', */

  const rowsSmsNgIndividual = useMemo(
    () => [
      user.cliente?.modulos_permisos?.env_sms_sim_ng_gral
        ? createData(
            'Envios Individual',
            'env_sms_sim_ng_v',
            'env_sms_sim_ng_e',
          )
        : null,
    ],
    [createData, user.cliente?.permisos_modulos_editar],
  );

  const rowsSmsNgMasivo = useMemo(
    () => [
      user.cliente?.modulos_permisos?.env_sms_mas_ng_gral
        ? createData(`Envio Masivo`, 'env_sms_mas_ng_v', 'env_sms_mas_ng_e')
        : null,
      user.cliente?.modulos_permisos?.api_doc_sms_ng_gral
        ? createData(`Api Sms`, 'api_doc_sms_ng_v', 'api_doc_sms_ng_e')
        : null,
      user.cliente?.modulos_permisos?.status_sms_ng_gral
        ? createData(`Estado Campaña`, 'status_sms_ng_v', 'status_sms_ng_e')
        : null,
    ],
    [createData, user.cliente?.permisos_modulos_editar],
  );
  /* 'rep_sms_ng_mod',
  'rep_sms_status_ng_v',
  'rep_sms_dia_ng_v',
  'rep_sms_fecha_ent_ng_v',
  'rep_sms_fecha_sal_ng_v',
  'rep_sms_env_ng_v',
  'rep_sms_rec_ng_v', */
  const rowsModuloReportesSmsNg = useMemo(
    () => [
      user.cliente?.modulos_permisos?.rep_sms_mod_ng_gral
        ? createData('Módulo Reportes SMS-NG', 'rep_sms_ng_mod')
        : null,
      user.cliente?.modulos_permisos?.rep_sms_status_ng_gral
        ? createData(`Estados Salientes`, 'rep_sms_status_ng_v')
        : null,
      user.cliente?.modulos_permisos?.rep_sms_fecha_sal_ng_gral
        ? createData(`Sms Salientes`, 'rep_sms_fecha_sal_ng_v')
        : null,
      user.cliente?.modulos_permisos?.rep_sms_fecha_ent_ng_gral
        ? createData(`Sms Entrantes`, 'rep_sms_fecha_ent_ng_v')
        : null,
      user.cliente?.modulos_permisos?.rep_sms_dia_ng_gral
        ? createData('Resumen por fecha', 'rep_sms_dia_ng_v')
        : null,
      user.cliente?.modulos_permisos?.rep_sms_env_ng_gral
        ? createData('Exportar Salientes', 'rep_sms_env_ng_v')
        : null,
      user.cliente?.modulos_permisos?.rep_sms_rec_ng_gral
        ? createData('Exportar Entrantes', 'rep_sms_rec_ng_v')
        : null,
    ],
    [createData, user.cliente?.permisos_modulos_editar],
  );

  /* 'tick_modulo',
  'tick_req_v',
  'tick_req_e',
  'tick_inc_v',
  'tick_inc_e', */
  const rowsModuloTickets = useMemo(
    () => [
      user.cliente?.modulos_permisos?.tick_modulo_gral
        ? createData('Módulo Tickets', 'tick_modulo')
        : null,
      user.cliente?.modulos_permisos?.tick_req_gral
        ? createData(`Requerimientos`, 'tick_req_v', 'tick_req_e')
        : null,
      user.cliente?.modulos_permisos?.tick_inc_gral
        ? createData(`Incidentes`, 'tick_inc_v', 'tick_inc_e')
        : null,
    ],
    [createData, user.cliente?.permisos_modulos_editar],
  );

  /* 'mv_modulo',
  'mv_list_v',
  'mv_list_e', */
  const rowsModuloMaquinasVirtuales = useMemo(
    () => [
      user.cliente?.modulos_permisos?.mv_modulo_gral
        ? createData('Módulo Maquinas Virtuales', 'mv_modulo')
        : null,
      user.cliente?.modulos_permisos?.mv_list_gral
        ? createData(`Listar Maquinas`, 'mv_list_v', 'mv_list_e')
        : null,
    ],
    [createData, user.cliente?.permisos_modulos_editar],
  );

  const rowsModuloDashboard = useMemo(
    () => [
      user.cliente?.modulos_permisos?.dash_modulo_gral
        ? createData('Módulo DashBoard', 'dash_modulo')
        : null,
      user.cliente?.modulos_permisos?.dash_tel_gral
        ? createData(`Dashboard Telefonia`, 'dash_tel_v')
        : null,
      user.cliente?.modulos_permisos?.dash_sms_gral
        ? createData(`Dashboard Sms`, 'dash_sms_v')
        : null,
      user.cliente?.modulos_permisos?.dash_sms_ng_gral
        ? createData(`Dashboard Sms-ng`, 'dash_sms_ng_v')
        : null,
    ],
    [createData, user.cliente?.permisos_modulos_editar],
  );
  const rowsModuloConfiguracion = useMemo(
    () => [
      user.cliente?.modulos_permisos?.cnf_modulo_gral
        ? createData('Módulo Configuracion', 'cnf_modulo')
        : null,
      user.cliente?.modulos_permisos?.cnf_usua_gral
        ? createData(`Usuarios`, 'cnf_usua_v', 'cnf_usua_e')
        : null,
    ],
    [
      createData,
      user.cliente?.permisos_modulos_editar?.cnf_modulo_gral,
      user.cliente?.permisos_modulos_editar?.cnf_usua_gral,
    ],
  );

  const rowsModuloHistorial = [
    user.cliente?.modulos_permisos?.hist_modulo_gral
      ? createData('Módulo Historial', 'hist_modulo')
      : null,
    user.cliente?.modulos_permisos?.hist_action_gral
      ? createData(`Detalle`, 'hist_action_v')
      : null,
  ];

  /*  const rowsModuloHistorial = useMemo(
    () => [
      user.cliente?.modulos_permisos?.hist_modulo_gral
        ? createData('Módulo Historial', 'hist_modulo')
        : null,
      user.cliente?.modulos_permisos?.hist_action_gral
        ? createData(`Detalle`, 'hist_action_v')
        : null,
    ],
    [
      createData,
      user.cliente?.permisos_modulos_editar?.hist_modulo_gral,
      user.cliente?.permisos_modulos_editar?.hist_action_v,
    ],
  ); */

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          width: '100%',
          height: '100%',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <CircularProgress />
      </Box>
    );
  } else {
    return (
      <Box sx={{ position: 'relative', height: '65%' }}>
        <Typography sx={{ margin: 1, p: 2 }} variant={'h5'}>
          PERMISOS A MÓDULOS
        </Typography>
        <form onSubmit={formik.handleSubmit} style={{ height: '100%' }}>
          <TableContainer className="formulario" component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead
                sx={{
                  borderTop:
                    theme.palette.mode === 'dark'
                      ? ' 1px solid rgb(81, 81, 81) '
                      : ' 1px solid rgb(224, 224, 224) ',
                }}
              >
                <TableRow>
                  <TableCell
                    sx={{ backgroundColor: 'transparent' }}
                    colSpan={1}
                  >
                    CONFIGURACIÓN DE PERMISOS
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ backgroundColor: 'transparent' }}
                    colSpan={1}
                  >
                    VER
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ backgroundColor: 'transparent' }}
                    colSpan={1}
                  >
                    EDITAR
                  </TableCell>
                </TableRow>
                {/* <TableRow>
                  <TableCell colSpan={3}>TELEFONÍA</TableCell>
                </TableRow> */}
              </TableHead>
              <TableBody>
                {user?.cliente?.clie_tel_nac_sal_serv &&
                (user?.cliente?.modulos_permisos?.rep_modulo_gral ||
                  user?.cliente?.modulos_permisos?.adm_modulo_gral ||
                  user?.cliente?.modulos_permisos?.gra_modulo_gral) ? (
                  <TableRow>
                    <TableCell
                      colSpan={3}
                      sx={{
                        fontWeight: 'bold',
                        backgroundColor: '#2065D1',
                        borderRadius: '0px',
                        boxShadow: 'inset 8px 0 0 #2065D1',
                        color: 'white',
                      }}
                      align="center"
                    >
                      TELEFONÍA
                    </TableCell>
                  </TableRow>
                ) : null}
              </TableBody>
              {user?.cliente?.modulos_permisos?.rep_modulo_gral &&
              user?.cliente?.clie_tel_nac_sal_serv ? (
                <TableBodyPermisos
                  formik={formik}
                  rows={rowsTelefonia.filter((row) => row)}
                />
              ) : null}
              {user?.cliente?.modulos_permisos?.adm_modulo_gral &&
              user?.cliente?.clie_tel_nac_sal_serv ? (
                <TableBodyPermisos
                  formik={formik}
                  rows={rowsAdministracion.filter((row) => row)}
                />
              ) : null}
              {user?.cliente?.modulos_permisos?.gra_modulo_gral &&
              user?.cliente?.clie_tel_nac_sal_serv ? (
                <TableBodyPermisos
                  formik={formik}
                  rows={rowsGraficos.filter((row) => row)}
                />
              ) : null}

              {user?.cliente?.clie_sms_serv &&
              (user?.cliente?.modulos_permisos?.rep_sms_modulo_gral ||
                user?.cliente?.modulos_permisos?.env_sms_simple_gral ||
                user?.cliente?.modulos_permisos?.env_sms_masivo_gral) ? (
                <TableBody>
                  <TableRow>
                    <TableCell
                      colSpan={3}
                      sx={{
                        fontWeight: 'bold',
                        backgroundColor: '#2065D1',
                        borderRadius: '0px',
                        boxShadow: 'inset 8px 0 0 #2065D1',
                        color: 'white',
                      }}
                      align="center"
                    >
                      SMS
                    </TableCell>
                  </TableRow>
                </TableBody>
              ) : null}

              {user?.cliente?.clie_sms_serv &&
              user?.cliente?.modulos_permisos?.env_sms_simple_gral ? (
                <TableBodyPermisos
                  formik={formik}
                  rows={rowModuloSmsEnvioIndividual.filter((row) => row)}
                />
              ) : null}
              {user?.cliente?.clie_sms_serv &&
              user?.cliente?.modulos_permisos?.env_sms_masivo_gral ? (
                <TableBodyPermisos
                  formik={formik}
                  rows={rowModuloSmsEnvioMasivo.filter((row) => row)}
                />
              ) : null}
              {user?.cliente?.clie_sms_serv &&
              user?.cliente?.modulos_permisos?.rep_sms_modulo_gral ? (
                <TableBodyPermisos
                  formik={formik}
                  rows={rowModuloReportesSms.filter((row) => row)}
                />
              ) : null}
              {user?.cliente?.clie_sms_ng_serv &&
              (user?.cliente?.modulos_permisos?.rep_sms_mod_ng_gral ||
                user?.cliente?.modulos_permisos?.env_sms_sim_ng_gral ||
                user?.cliente?.modulos_permisos?.env_sms_mas_ng_gral) ? (
                <TableBody>
                  <TableRow /*  */>
                    <TableCell
                      colSpan={3}
                      sx={{
                        fontWeight: 'bold',
                        backgroundColor: '#2065D1',
                        borderRadius: '0px',
                        boxShadow: 'inset 8px 0 0 #2065D1',
                        color: 'white',
                      }}
                      align="center"
                    >
                      SMS-NG
                    </TableCell>
                  </TableRow>
                </TableBody>
              ) : null}

              {user?.cliente?.clie_sms_ng_serv &&
              user?.cliente?.modulos_permisos?.env_sms_sim_ng_gral ? (
                <TableBodyPermisos
                  formik={formik}
                  rows={rowsSmsNgIndividual.filter((row) => row)}
                />
              ) : null}
              {user?.cliente?.clie_sms_ng_serv &&
              user?.cliente?.modulos_permisos?.env_sms_mas_ng_gral ? (
                <TableBodyPermisos
                  formik={formik}
                  rows={rowsSmsNgMasivo.filter((row) => row)}
                />
              ) : null}
              {user?.cliente?.clie_sms_ng_serv &&
              user?.cliente?.modulos_permisos?.rep_sms_mod_ng_gral ? (
                <TableBodyPermisos
                  formik={formik}
                  rows={rowsModuloReportesSmsNg.filter((row) => row)}
                />
              ) : null}
              {user?.cliente?.modulos_permisos?.tick_modulo_gral ? (
                <>
                  <TableBody>
                    <TableRow>
                      <TableCell
                        colSpan={3}
                        sx={{
                          fontWeight: 'bold',
                          backgroundColor: '#2065D1',
                          borderRadius: '0px',
                          boxShadow: 'inset 8px 0 0 #2065D1',
                          color: 'white',
                        }}
                        align="center"
                      >
                        TICKET
                      </TableCell>
                    </TableRow>
                  </TableBody>
                  <TableBodyPermisos
                    formik={formik}
                    rows={rowsModuloTickets.filter((row) => row)}
                  />
                </>
              ) : null}
              {user?.cliente?.clie_mv_serv &&
              user.cliente?.modulos_permisos?.mv_modulo_gral ? (
                <>
                  <TableBody>
                    <TableRow>
                      <TableCell
                        colSpan={3}
                        sx={{
                          fontWeight: 'bold',
                          backgroundColor: '#2065D1',
                          borderRadius: '0px',
                          boxShadow: 'inset 8px 0 0 #2065D1',
                          color: 'white',
                        }}
                        align="center"
                      >
                        MÁQUINAS-VIRTUALES
                      </TableCell>
                    </TableRow>
                  </TableBody>
                  <TableBodyPermisos
                    formik={formik}
                    rows={rowsModuloMaquinasVirtuales.filter((row) => row)}
                  />
                </>
              ) : null}

              {user.cliente?.modulos_permisos?.dash_modulo_gral ? (
                <>
                  <TableBody>
                    <TableRow>
                      <TableCell
                        colSpan={3}
                        sx={{
                          fontWeight: 'bold',
                          backgroundColor: '#2065D1',
                          borderRadius: '0px',
                          boxShadow: 'inset 8px 0 0 #2065D1',
                          color: 'white',
                        }}
                        align="center"
                      >
                        DASHBOARD
                      </TableCell>
                    </TableRow>
                  </TableBody>
                  <TableBodyPermisos
                    formik={formik}
                    rows={rowsModuloDashboard.filter((row) => row)}
                  />
                </>
              ) : null}
              {user.cliente?.modulos_permisos?.hist_modulo_gral ? (
                <>
                  <TableBody>
                    <TableRow>
                      <TableCell
                        colSpan={3}
                        sx={{
                          fontWeight: 'bold',
                          backgroundColor: '#2065D1',
                          borderRadius: '0px',
                          boxShadow: 'inset 8px 0 0 #2065D1',
                          color: 'white',
                        }}
                        align="center"
                      >
                        HISTORIAL
                      </TableCell>
                    </TableRow>
                  </TableBody>
                  <TableBodyPermisos
                    formik={formik}
                    rows={rowsModuloHistorial.filter((row) => row)}
                  />
                </>
              ) : null}

              {user.cliente?.modulos_permisos?.cnf_modulo_gral ? (
                <>
                  <TableBody>
                    <TableRow>
                      <TableCell
                        colSpan={3}
                        sx={{
                          fontWeight: 'bold',
                          backgroundColor: '#2065D1',
                          borderRadius: '0px',
                          boxShadow: 'inset 8px 0 0 #2065D1',
                          color: 'white',
                        }}
                        align="center"
                      >
                        CONFIGURACIÓN
                      </TableCell>
                    </TableRow>
                  </TableBody>
                  <TableBodyPermisos
                    formik={formik}
                    rows={rowsModuloConfiguracion.filter((row) => row)}
                  />
                </>
              ) : null}
            </Table>
          </TableContainer>
        </form>
      </Box>
    );
  }
};

export default FormPermisos;
